import { render, staticRenderFns } from "./work_detail.vue?vue&type=template&id=15600943&scoped=true"
import script from "./work_detail.vue?vue&type=script&lang=js"
export * from "./work_detail.vue?vue&type=script&lang=js"
import style0 from "./work_detail.vue?vue&type=style&index=0&id=15600943&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15600943",
  null
  
)

export default component.exports